import { isNotUndefined, isNullable, isRecord } from 'effect/Predicate';
import { log } from './logger';
export const formatDate = (timestamp, locale = 'en-US', options = {}) => {
    const currentDateTime = new Date(+timestamp);
    const dateString = currentDateTime.toLocaleDateString(locale, Object.assign({ month: 'short', day: 'numeric' }, options));
    const timeString = currentDateTime.toLocaleTimeString(locale, Object.assign({ hour: '2-digit', minute: '2-digit' }, options));
    return `${timeString}, ${dateString}`;
};
export const printTranscript = (printContentRef, iFrameId, onError) => {
    var _a, _b, _c;
    try {
        const content = (_a = printContentRef.current) === null || _a === void 0 ? void 0 : _a.innerHTML;
        const printIframeDOM = document.getElementById(iFrameId);
        const printWindow = printIframeDOM === null || printIframeDOM === void 0 ? void 0 : printIframeDOM.contentWindow;
        const printDocument = printWindow === null || printWindow === void 0 ? void 0 : printWindow.document;
        if (isNullable(content) || isNullable(printDocument)) {
            log.error('Content or Print Iframe are null');
            return;
        }
        printWindow.focus();
        printDocument.open();
        printDocument.write(content);
        printDocument.write('<script>function printPage() { print(); }</script>');
        printDocument
            .querySelectorAll('.advisor-thumbnail')
            .forEach((img) => img.remove());
        printDocument.querySelectorAll('.attachment').forEach((img) => {
            img.style.width = '100px';
            img.style.height = '100px';
            img.style.objectFit = 'cover';
        });
        printDocument.querySelectorAll('svg').forEach((tick) => tick.remove());
        printDocument
            .querySelectorAll('.message')
            .forEach((customerMessage) => {
            const separator = printDocument.createElement('hr');
            customerMessage.after(separator);
        });
        printDocument.close();
        (_c = (_b = printWindow).printPage) === null || _c === void 0 ? void 0 : _c.call(_b);
    }
    catch (e) {
        onError(e);
    }
};
export function createMarkup(message) {
    return { __html: message };
}
export function getRandomInt(min, max) {
    const newMin = Math.ceil(min);
    const newMax = Math.floor(max);
    return Math.floor(Math.random() * (newMax - newMin + 1)) + newMin;
}
const mergeObjects = (oldObj, newObj) => {
    const result = Object.assign(Object.assign({}, oldObj), newObj);
    for (const [key, value] of Object.entries(newObj)) {
        if (isRecord(result[key]) && isRecord(value)) {
            result[key] = mergeObjects(result[key], value);
        }
    }
    return result;
};
export const mergeArrays = (oldObjects, newObjects) => {
    const updatedOldObjects = oldObjects.map(oldObj => {
        const newObj = newObjects.find(o => o.id === oldObj.id);
        return isNotUndefined(newObj) ? mergeObjects(oldObj, newObj) : oldObj;
    });
    const filteredNewObjects = newObjects.filter(obj => !oldObjects.some(obj2 => obj.id === obj2.id));
    return [...updatedOldObjects, ...filteredNewObjects];
};
